import React, { useState } from "react";
// import { useTranslation } from "react-i18next";
import Typography from 'apollo-react/components/Typography';
import Button from 'apollo-react/components/Button';
import PlusIcon from 'apollo-react-icons/Plus';
import PlusCircle from 'apollo-react-icons/PlusCircle';
import makeStyles from '@mui/styles/makeStyles';
import Paper from 'apollo-react/components/Paper';
import { Background } from "reactflow";

const styles = {
  buttons: {
    width: "150px",
    padding: "10px",
    margin: "4px 0"
  },
  typography: {
    margin: "12px 0 3px 0",
  },
  paper: {
    padding: "18px",
    background: "#ECF3FF",
    border: 'none'
  }
};
const useStyles = makeStyles(styles);

const Sidebar = () => {
  const classes = useStyles();
  const onDragStart = (event, type, results) => {
    event.dataTransfer.setData("application/reactflow", type);
    event.dataTransfer.setData("data", JSON.stringify(results));
    event.dataTransfer.effectAllowed = "move";
  };

  return (
    <Paper className={classes.paper}>
        <Typography variant="body2" style={{ margin: '8px 0' }}>You can drag these nodes to the pane on the right.</Typography>
        <Typography className={classes.typography} variant="subtitle" gutterBottom emphasis="high">Create New Flow</Typography>

        <div className={classes.sidebar_buttons_div}>
          <Button className={classes.buttons} variant="secondary" disabled icon={PlusIcon}>
            Start Flow
          </Button>
        </div>

        <div className={classes.sidebar_buttons_div}>
          <Button 
            className={classes.buttons}
            onDragStart={(event) => onDragStart(event, "output" )}
            draggable
            variant="secondary" icon={PlusIcon}>
            End Flow
          </Button>
        </div>

        <Typography className={classes.typography} variant="subtitle" gutterBottom emphasis="high">Stages</Typography>

        <div className={classes.sidebar_buttons_div}>
          <Button
            className={classes.buttons}
            onDragStart={ (event) => onDragStart( event, "FormStage" ) }
            draggable
            variant="secondary" icon={PlusCircle}>
            Add Stage
          </Button>
        </div>
    </Paper>
  );
};

export default Sidebar;
